export default __webpack_public_path__ + "static/media/rs_raceweek_italia_cochemoto_330x330(2).e7c90426.webp";